module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict02_obj01-e2ecae18abe160757ff6173c4fa89889.webp";